<template>
  <b-overlay :show="isLoading" rounded="sm">
    <slot></slot>
  </b-overlay>
</template>

<script>
import {mapGetters} from 'vuex';
import {BOverlay} from "bootstrap-vue";
export default {
  computed:{
    ...mapGetters({isLoading : 'isLoading'})
  },
  components:{
    BOverlay
  },
}
</script>